const deglawyTrophiesPath = '/deglawy/trophies';
export const getDeglawyTrophies = `${deglawyTrophiesPath}?status=all`;
export const getDeglawyTrophyById = (id: number) => `${deglawyTrophiesPath}/${id}?`;
export const createDeglawyTrophy = `${deglawyTrophiesPath}`;
export const updateDeglawyTrophy = (id: number) => `${deglawyTrophiesPath}/${id}`;
export const updateDeglawyTrophyStatus = (id: number) => `${deglawyTrophiesPath}/${id}/activation`;
